// extracted by mini-css-extract-plugin
export default {"app":"App_app__BDRcg","container":"App_container__H7W+l","mainContent":"App_mainContent__Fxsqh"};